module.exports = __webpack_public_path__ + "static/media/smruti_pachpute.538cae74.png";